import { render } from "./ConfirmPaymentModal.vue?vue&type=template&id=ed85a374&scoped=true&ts=true"
import script from "./ConfirmPaymentModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmPaymentModal.vue?vue&type=script&lang=ts"

import "./ConfirmPaymentModal.vue?vue&type=style&index=0&id=ed85a374&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed85a374"]])

export default __exports__